<template>
    <div class="subscription">

        <div v-if="isLoading" class="subscription__inner">
            <v-progress-circular color="white" indeterminate></v-progress-circular>
        </div>

        <div v-else-if="hasSubscription" class="subscription__inner">

            <div class="subscription__detail">
                <div class="value">
                    {{ getSubscriptionFormatted }}
                </div>
                <div class="description">
                    Your Subscription
                </div>
            </div>

            <div class="subscription__detail" :class="{ 'quota-warning': hasQuotaWarning }">
                <div class="value">
                    {{ getQuotaFormatted }}
                </div>
                <div class="description">
                    Remaining Quota
                </div>
            </div>

            <div class="subscription__detail">
                <div class="value">
                    {{ getExpiresFormatted }}
                </div>
                <div v-if="isRenewal" class="description">
                    Automatic Renewal
                </div>
                <div v-else class="description">
                    Expire Date
                </div>
            </div>

            <div class="subscription__action">
                <v-btn 
                    color="white" 
                    variant="outlined" 
                    @click="openRoute({ route: routeSubscription })">
                    Manage Plan
                </v-btn>
            </div>

        </div>

        <div v-else class="subscription__inner">
            <div class="no-subscription">
                Please select a subscription plan to continue using the service.
            </div>
            <v-btn 
                color="white" 
                variant="outlined" 
                @click="openRoute({ route: routeSubscription })">
                    Select Plan
            </v-btn>
        </div>
    </div>
</template>

<script>
import ROUTES from '@generio-ai/library-legacy/constants/routes'
import { mapGetters, mapActions } from '@generio-ai/library-legacy/plugins/vuex'

export default {
    name: 'Subscription',
    data() {
        return {
            quota: 0,
            expires: 'Never'
        }
    },
    computed: {
        ...mapGetters('subscriptions', [
            'isLoading',
            'isRenewal',
            'hasSubscription',
            'getSubscriptionFormatted',
            'getQuota',
            'getQuotaFormatted',
            'getExpiresFormatted'
        ]),
        hasQuotaWarning() {
            if (this.getQuota === -1) return false
            return this.getQuota < 5
        },
        routeSubscription() {
            return ROUTES.ACCOUNT.SUBSCRIPTION
        }
    },
    methods: {
        ...mapActions('router', [
            'openRoute'
        ]),
        ...mapActions('subscriptions', [
            'fetch'
        ])
    },
    mounted() {
        this.fetch()
    }
}
</script>

<style scoped>
.subscription {
    width: 100%;
    padding: 20px;
    border-radius: 8px;
    color: rgb(var(--v-theme-white));
    background: linear-gradient(
        145deg, 
        rgb(var(--v-theme-color1)) 0%, 
        rgb(var(--v-theme-color2)) 50%, 
        rgb(var(--v-theme-color3)) 100%
    );
    overflow: hidden;
    box-shadow: 0px 0px 15px rgba(var(--v-theme-shadow1), 0.5);
}

.subscription .subscription__inner {
    width: 100%;
    min-height: 50px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
}

.subscription .subscription__detail {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.subscription .subscription__detail .value {
    font-size: 1.2em;
    font-weight: bold;
    text-transform: capitalize;
}

.subscription .subscription__detail .description {
    font-size: 0.8em;
}

.subscription .quota-warning {
    color: red;
}

.subscription .subscription__action {
    flex: 1;
    display: flex;
    justify-content: flex-end;
    align-items: center;
}

.subscription .no-subscription {
    flex-grow: 1;
}

@media (max-width: 800px) {
    .subscription .subscription__inner {
        flex-direction: column;
        justify-content: space-between;
        gap: 10px;
    }

    .subscription .subscription__action {
        justify-content: center;
        margin-top: 10px;
    }

    .subscription .no-subscription {
        text-align: center;
        margin-bottom: 10px;
    }
}
</style>
